import React from "react";
import { Redirect, Route } from "react-router";
import { useSelector } from "react-redux";
import { getOidcUser } from "@store/selectors/oidc";
import { AppRoutes } from "@utils/enums";
const PrivateRoute = ({ component: Component, ...rest }) => {
    const user = useSelector(getOidcUser);
    if (user === undefined) {
        return null;
    }
    return (React.createElement(Route, Object.assign({}, rest, { render: (props) => !user || user.expired ? (React.createElement(Redirect, { to: {
                pathname: AppRoutes.Home
            } })) : (React.createElement(Component, Object.assign({}, props))) })));
};
export default PrivateRoute;
